import { API } from "../api/axios";
const END_POINT ="/dashboard"
const END_POINT_MSGS_STAT = "/messages-statistics";
const END_POINT_HMWS_STAT = "/homeworks-statistics";
const END_POINT_USERS_STAT = "/users-statistics";
const END_POINT_CLASSES_STAT = "/classes-statistics";
const END_POINT_STUDENTS_STAT = "/students-statistics";
const END_POINT_TEACHERS_STAT = "/teachers-statistics";
const END_POINT_MSG_BY_MONTH ="/statistics/messages-by-month";
const END_POINT_HMWS_BY_MONTH ="/statistics/homeworks-by-month"
const END_POINT_NB_CNX="/statistics/stats-connection";
const END_POINT_LAST ="/last-article";
const END_POINT_SOLD = "/solde-School";
const END_POINT_YEARS_LIST = "/school-year-list";

class DashboardService {
    getNbCnx(params) {
        return API.get(`${END_POINT}${END_POINT_NB_CNX}`, params);
    }
    getAllMsg() {
        return API.get(`${END_POINT}${END_POINT_MSGS_STAT}`);
    }
    getAllHmw() {
        return API.get(`${END_POINT}${END_POINT_HMWS_STAT}`);
    }
    getAllUser() {
        return API.get(`${END_POINT}${END_POINT_USERS_STAT}`);
    }
    getAllClasse() {
        return API.get(`${END_POINT}${END_POINT_CLASSES_STAT}`);
    }
    getAllStudent() {
        return API.get(`${END_POINT}${END_POINT_STUDENTS_STAT}`);
    }
    getAllTeacher() {
        return API.get(`${END_POINT}${END_POINT_TEACHERS_STAT}`);
    }
    getAllMsgByMonth() {
        return API.get(`${END_POINT}${END_POINT_MSG_BY_MONTH}`);
    }
    getAllHmwByMonth() {
        return API.get(`${END_POINT}${END_POINT_HMWS_BY_MONTH}`);
    }
    getLast() {
        return API.get(`${END_POINT}${END_POINT_LAST}`);
    }
    getSolde(){
        return API.get(`${END_POINT}${END_POINT_SOLD}`);
    }
    getSchoolYears() {
        return API.get(`${END_POINT_YEARS_LIST}`);
    }
}

export default new DashboardService();